import React from 'react';

import ContactForm from '../ContactForm';
import ItemForm from '../ItemForm';
import PropertyForm from '../PropertyForm';
import ServiceRequestForm from '../ServiceRequestForm';

const WizardBody = ({ active, onBack, onClose,onSubmitContactForm, saveProperty, onSaveItem, tabList }) => {
  switch(active) {
    case 'Service Request':
      return <ServiceRequestForm onClose={onBack} onExit={onClose} />;
    case 'Property':
      return <PropertyForm onClose={onBack} onSaveProperty={saveProperty} tabList={tabList}/>;
    case 'Contact':
      return <ContactForm onClose={onBack} onSubmit={onSubmitContactForm}/>;
    case 'Item':
      return <ItemForm onClose={onBack} onSaveItem={onSaveItem}/>;
    default:
      return null;
  }
};

export default WizardBody;
